
import './App.css';
import Garelly from './screen/Garelly';
// import Garelly from './screen/Garelly';

function App() {
  return (
    <div>
      <Garelly/>
    </div>
  );
}

export default App;
